import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IGuardian } from 'src/app/core/models/user';

export const GuardianActions = createActionGroup({
  source: 'Guardian',
  events: {
    'Load Loggedin Guardian': emptyProps(),
    'Load Loggedin Guardian Success': props<{ data: IGuardian }>(),
    'Load Guardians': emptyProps(),
    'Load Guardians Success': props<{ data: IGuardian[] }>(),
    'Load Guardians Failure': props<{ error: unknown }>(),
    'Add Guardian': props<{ guardian: IGuardian }>(),
    'Update Guardian': props<{ guardian: IGuardian }>(),
    'Update Guardian Email': props<{ guardian: IGuardian }>(),
    'Update Guardian Phone': props<{ guardian: IGuardian }>(),
    'Add Person Phone Number': props<{ guardian: IGuardian }>(),
    'Update Learner Access': props<{ guardian: IGuardian }>(),
    'Update Learner Access Success': props<{ guardian: IGuardian }>(),
    'Update Learner Access Failure': props<{ error: unknown }>(),
    'Update Guardian Success': props<{ guardian: IGuardian }>(),
    'Update Guardian Failure': props<{ error: unknown }>(),
    'Delete Guardian': props<{ id: string }>(),
    'Select Guardian': props<{ id: string }>(),
    'Set Loggedin Guardian': props<{ id: string }>(),
    'Update Guardian Picture': props<{ guardianid: string, pictureFile: File | null, pictureId: string | null, pictureUrl: string }>(),
    'Delete Phone Number By ID': props<{ phoneNumberId: string }>(),
    'Delete Phone Number Success': props<{ phoneNumberId: string }>(),
    'Delete Phone Number Failure': props<{ error: string }>(),
    'Send Guardian Invite': props<{ guardian: IGuardian }>(),
    'Send Guardian Invite Success': props<{ guardian: IGuardian }>(),
    'Send Guardian Invite Failure': props<{ error: unknown }>()
  }
});